import React, { useEffect, useRef } from "react";
import useAuth from "../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import orderPlaced from "../assets/lottie/order-placed.json";
import axiosPrivate from "../axios/axiosPrivate";

const ThankYou = () => {
  const sheetContainerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { token, user, logout, authLoading } = useAuth();

  const draftOrderId = location.state?.draftOrderId;
  const orderAmount = location.state?.value;

  const orderStatusUrl = location.state?.orderStatusUrl;
  const codOrderAmount = location.state?.orderAmount;
  const contentId = location.state?.contentId || [];

  //   const draftOrderId = 1266784272663;

  const getDraftOrderDetail = async (draftId) => {
    try {
      const res = await axiosPrivate.post("/orders/get-draft-order-detail", {
        draftId,
      });

      const orderStatusUrl = res?.data?.orderStatusUrl;

      const productIds = res?.data?.orderData?.line_items.map(
        (item) => item.product_id
      );

      if (!orderStatusUrl) {
        navigate("/not-found", { replace: true });
        return;
      }

      // THIS IS FOR OUTSIDE IFRAME
      window.parent.postMessage(
        {
          type: "REDIRECT_TO_URL",
          payload: orderStatusUrl,
          orderAmount: orderAmount / 100,
          contentId: productIds || [],
        },
        "*"
      );
    } catch (error) {
      console.error("Error fetching order status:", error);
      navigate("/not-found", { replace: true });
    }
  };

  useEffect(() => {
    // FOR COD
    if (orderStatusUrl) {
      window.parent.postMessage(
        {
          type: "REDIRECT_TO_URL",
          payload: orderStatusUrl,
          orderAmount: codOrderAmount || 0,
          contentId: contentId,
        },
        "*"
      );
      return;
    }

    // FOR ONLINE
    if (!draftOrderId) {
      navigate("/not-found", { replace: true });
      return;
    }
    getDraftOrderDetail(draftOrderId);
  }, []);

  if (!draftOrderId && !orderStatusUrl) return null;

  return (
    <div className="hayd-checkout-outer">
      <div className="hayd-checkout-inner w-[100vw] h-[100dvh] overflow-hidden flex justify-center items-center bg-black bg-opacity-50">
        <div
          ref={sheetContainerRef}
          className="hayd-checkout-main relative max-w-[500px] w-[100%] h-[100%] bg-slate-100 overflow-hidden p-4 flex justify-center items-center flex-col"
        >
          <div className="justify-center flex mb-4">
            <Lottie
              animationData={orderPlaced}
              loop={false}
              autoplay={true}
              style={{ width: "80px" }}
            />
          </div>
          <div className="mb-4">
            <p className="text-[20px] supreme-bold text-green-700">Thank You</p>
          </div>
          <div className="mb-2">
            <p className="text-[38px] text-green-700 supreme-bold">
              Order Placed
            </p>
          </div>
          <div className="text-[14px] general-sans-medium">
            Please dont refresh the page.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
